import {
    ROCLOSE,
    VIEW_ROC,
  } from "./ApiRoutes";
  import { authData } from "./services";
  
  export const makeROC = async (data: object) => {
    const response = await authData.put(ROCLOSE, data);
    return response?.data;
  };

  export const viewROC  = async (id: number) => {
    const response = await authData.get(`${VIEW_ROC}/${id}`);
    return response?.data;
  };